import React from 'react';
import './App.css';

import SearchTool from './scenes/SearchTool/SearchTool'

function App() {
    return (
        <div className="App">
            <SearchTool />
        </div>
    );
}

export default App;
